import { render, staticRenderFns } from "./ProposalSign.vue?vue&type=template&id=92330cc4&"
import script from "./ProposalSign.vue?vue&type=script&lang=js&"
export * from "./ProposalSign.vue?vue&type=script&lang=js&"
import style0 from "./ProposalSign.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports